var _g, _defs;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgMailCardIcon11(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    viewBox: "0 0 44 44",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_1433_48261)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M26.0621 4.26367H10.4234C9.38645 4.26367 8.392 4.67558 7.65879 5.40879C6.92558 6.142 6.51367 7.13645 6.51367 8.17337V39.4509C6.51367 40.4878 6.92558 41.4823 7.65879 42.2155C8.392 42.9487 9.38645 43.3606 10.4234 43.3606H33.8815C34.9185 43.3606 35.9129 42.9487 36.6461 42.2155C37.3793 41.4823 37.7912 40.4878 37.7912 39.4509V15.9928L26.0621 4.26367Z",
    fill: "url(#paint0_linear_1433_48261)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M23.9266 31.4973C23.9266 31.8089 23.9572 32.0974 24.0185 32.363C24.0798 32.6235 24.1692 32.8508 24.2867 33.0449C24.4041 33.2339 24.5446 33.382 24.708 33.4892C24.8766 33.5914 25.063 33.6425 25.2673 33.6425C25.4767 33.6425 25.6631 33.5914 25.8266 33.4892C25.99 33.382 26.1305 33.2339 26.248 33.0449C26.3654 32.8508 26.4548 32.6235 26.5161 32.363C26.5774 32.0974 26.608 31.8089 26.608 31.4973C26.608 31.1857 26.5774 30.8997 26.5161 30.6392C26.4548 30.3737 26.3654 30.1464 26.248 29.9574C26.1305 29.7633 25.99 29.6152 25.8266 29.513C25.6631 29.4058 25.4767 29.3522 25.2673 29.3522C25.063 29.3522 24.8766 29.4058 24.708 29.513C24.5446 29.6152 24.4041 29.7633 24.2867 29.9574C24.1692 30.1464 24.0798 30.3737 24.0185 30.6392C23.9572 30.8997 23.9266 31.1857 23.9266 31.4973ZM23.2754 31.4973C23.2754 30.961 23.3597 30.486 23.5282 30.0723C23.6968 29.6586 23.9292 29.3343 24.2254 29.0993C24.5267 28.8593 24.874 28.7393 25.2673 28.7393C25.6606 28.7393 26.0053 28.8593 26.3016 29.0993C26.6029 29.3343 26.8379 29.6586 27.0064 30.0723C27.175 30.486 27.2592 30.961 27.2592 31.4973C27.2592 32.0336 27.175 32.5086 27.0064 32.9223C26.8379 33.336 26.6029 33.6629 26.3016 33.9029C26.0053 34.1379 25.6606 34.2554 25.2673 34.2554C24.874 34.2554 24.5267 34.1379 24.2254 33.9029C23.9292 33.6629 23.6968 33.336 23.5282 32.9223C23.3597 32.5086 23.2754 32.0336 23.2754 31.4973Z",
    fill: "url(#paint1_linear_1433_48261)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M19.327 31.4973C19.327 31.8089 19.3576 32.0974 19.4189 32.363C19.4802 32.6235 19.5696 32.8508 19.6871 33.0449C19.8045 33.2339 19.945 33.382 20.1084 33.4892C20.277 33.5914 20.4634 33.6425 20.6677 33.6425C20.8771 33.6425 21.0635 33.5914 21.227 33.4892C21.3904 33.382 21.5309 33.2339 21.6483 33.0449C21.7658 32.8508 21.8552 32.6235 21.9165 32.363C21.9778 32.0974 22.0084 31.8089 22.0084 31.4973C22.0084 31.1857 21.9778 30.8997 21.9165 30.6392C21.8552 30.3737 21.7658 30.1464 21.6483 29.9574C21.5309 29.7633 21.3904 29.6152 21.227 29.513C21.0635 29.4058 20.8771 29.3522 20.6677 29.3522C20.4634 29.3522 20.277 29.4058 20.1084 29.513C19.945 29.6152 19.8045 29.7633 19.6871 29.9574C19.5696 30.1464 19.4802 30.3737 19.4189 30.6392C19.3576 30.8997 19.327 31.1857 19.327 31.4973ZM18.6758 31.4973C18.6758 30.961 18.7601 30.486 18.9286 30.0723C19.0971 29.6586 19.3295 29.3343 19.6258 29.0993C19.9271 28.8593 20.2744 28.7393 20.6677 28.7393C21.061 28.7393 21.4057 28.8593 21.702 29.0993C22.0033 29.3343 22.2383 29.6586 22.4068 30.0723C22.5754 30.486 22.6596 30.961 22.6596 31.4973C22.6596 32.0336 22.5754 32.5086 22.4068 32.9223C22.2383 33.336 22.0033 33.6629 21.702 33.9029C21.4057 34.1379 21.061 34.2554 20.6677 34.2554C20.2744 34.2554 19.9271 34.1379 19.6258 33.9029C19.3295 33.6629 19.0971 33.336 18.9286 32.9223C18.7601 32.5086 18.6758 32.0336 18.6758 31.4973Z",
    fill: "url(#paint2_linear_1433_48261)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M15.5371 29.8731V29.1989L17.3758 28.7393V34.1787H16.7246V29.5207L15.5371 29.8731Z",
    fill: "url(#paint3_linear_1433_48261)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M12.0879 29.8731V29.1989L13.9266 28.7393V34.1787H13.2754V29.5207L12.0879 29.8731Z",
    fill: "url(#paint4_linear_1433_48261)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M27.87 22.4997C27.87 22.8113 27.9006 23.0999 27.9619 23.3655C28.0232 23.6259 28.1126 23.8532 28.23 24.0473C28.3475 24.2363 28.488 24.3844 28.6514 24.4917C28.8199 24.5938 29.0064 24.6449 29.2107 24.6449C29.4201 24.6449 29.6065 24.5938 29.7699 24.4917C29.9334 24.3844 30.0738 24.2363 30.1913 24.0473C30.3088 23.8532 30.3982 23.6259 30.4595 23.3655C30.5207 23.0999 30.5514 22.8113 30.5514 22.4997C30.5514 22.1882 30.5207 21.9022 30.4595 21.6417C30.3982 21.3761 30.3088 21.1488 30.1913 20.9598C30.0738 20.7658 29.9334 20.6176 29.7699 20.5155C29.6065 20.4082 29.4201 20.3546 29.2107 20.3546C29.0064 20.3546 28.8199 20.4082 28.6514 20.5155C28.488 20.6176 28.3475 20.7658 28.23 20.9598C28.1126 21.1488 28.0232 21.3761 27.9619 21.6417C27.9006 21.9022 27.87 22.1882 27.87 22.4997ZM27.2188 22.4997C27.2188 21.9635 27.303 21.4885 27.4716 21.0748C27.6401 20.661 27.8725 20.3367 28.1687 20.1018C28.4701 19.8617 28.8174 19.7417 29.2107 19.7417C29.6039 19.7417 29.9487 19.8617 30.2449 20.1018C30.5463 20.3367 30.7812 20.661 30.9498 21.0748C31.1183 21.4885 31.2026 21.9635 31.2026 22.4997C31.2026 23.036 31.1183 23.511 30.9498 23.9247C30.7812 24.3384 30.5463 24.6653 30.2449 24.9054C29.9487 25.1403 29.6039 25.2578 29.2107 25.2578C28.8174 25.2578 28.4701 25.1403 28.1687 24.9054C27.8725 24.6653 27.6401 24.3384 27.4716 23.9247C27.303 23.511 27.2188 23.036 27.2188 22.4997Z",
    fill: "url(#paint5_linear_1433_48261)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M23.2821 22.4997C23.2821 22.8113 23.3127 23.0999 23.374 23.3655C23.4353 23.6259 23.5247 23.8532 23.6421 24.0473C23.7596 24.2363 23.9001 24.3844 24.0635 24.4917C24.2321 24.5938 24.4185 24.6449 24.6228 24.6449C24.8322 24.6449 25.0186 24.5938 25.1821 24.4917C25.3455 24.3844 25.4859 24.2363 25.6034 24.0473C25.7209 23.8532 25.8103 23.6259 25.8716 23.3655C25.9329 23.0999 25.9635 22.8113 25.9635 22.4997C25.9635 22.1882 25.9329 21.9022 25.8716 21.6417C25.8103 21.3761 25.7209 21.1488 25.6034 20.9598C25.4859 20.7658 25.3455 20.6176 25.1821 20.5155C25.0186 20.4082 24.8322 20.3546 24.6228 20.3546C24.4185 20.3546 24.2321 20.4082 24.0635 20.5155C23.9001 20.6176 23.7596 20.7658 23.6421 20.9598C23.5247 21.1488 23.4353 21.3761 23.374 21.6417C23.3127 21.9022 23.2821 22.1882 23.2821 22.4997ZM22.6309 22.4997C22.6309 21.9635 22.7151 21.4885 22.8837 21.0748C23.0522 20.661 23.2846 20.3367 23.5809 20.1018C23.8822 19.8617 24.2295 19.7417 24.6228 19.7417C25.0161 19.7417 25.3608 19.8617 25.657 20.1018C25.9584 20.3367 26.1933 20.661 26.3619 21.0748C26.5304 21.4885 26.6147 21.9635 26.6147 22.4997C26.6147 23.036 26.5304 23.511 26.3619 23.9247C26.1933 24.3384 25.9584 24.6653 25.657 24.9054C25.3608 25.1403 25.0161 25.2578 24.6228 25.2578C24.2295 25.2578 23.8822 25.1403 23.5809 24.9054C23.2846 24.6653 23.0522 24.3384 22.8837 23.9247C22.7151 23.511 22.6309 23.036 22.6309 22.4997Z",
    fill: "url(#paint6_linear_1433_48261)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M19.4805 20.8756V20.2014L21.3192 19.7417V25.1812H20.668V20.5231L19.4805 20.8756Z",
    fill: "url(#paint7_linear_1433_48261)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M15.2352 22.4997C15.2352 22.8113 15.2658 23.0999 15.3271 23.3655C15.3884 23.6259 15.4778 23.8532 15.5953 24.0473C15.7127 24.2363 15.8532 24.3844 16.0166 24.4917C16.1852 24.5938 16.3716 24.6449 16.5759 24.6449C16.7853 24.6449 16.9717 24.5938 17.1352 24.4917C17.2986 24.3844 17.4391 24.2363 17.5565 24.0473C17.674 23.8532 17.7634 23.6259 17.8247 23.3655C17.886 23.0999 17.9166 22.8113 17.9166 22.4997C17.9166 22.1882 17.886 21.9022 17.8247 21.6417C17.7634 21.3761 17.674 21.1488 17.5565 20.9598C17.4391 20.7658 17.2986 20.6176 17.1352 20.5155C16.9717 20.4082 16.7853 20.3546 16.5759 20.3546C16.3716 20.3546 16.1852 20.4082 16.0166 20.5155C15.8532 20.6176 15.7127 20.7658 15.5953 20.9598C15.4778 21.1488 15.3884 21.3761 15.3271 21.6417C15.2658 21.9022 15.2352 22.1882 15.2352 22.4997ZM14.584 22.4997C14.584 21.9635 14.6683 21.4885 14.8368 21.0748C15.0054 20.661 15.2377 20.3367 15.534 20.1018C15.8353 19.8617 16.1826 19.7417 16.5759 19.7417C16.9692 19.7417 17.3139 19.8617 17.6102 20.1018C17.9115 20.3367 18.1465 20.661 18.315 21.0748C18.4836 21.4885 18.5678 21.9635 18.5678 22.4997C18.5678 23.036 18.4836 23.511 18.315 23.9247C18.1465 24.3384 17.9115 24.6653 17.6102 24.9054C17.3139 25.1403 16.9692 25.2578 16.5759 25.2578C16.1826 25.2578 15.8353 25.1403 15.534 24.9054C15.2377 24.6653 15.0054 24.3384 14.8368 23.9247C14.6683 23.511 14.584 23.036 14.584 22.4997Z",
    fill: "url(#paint8_linear_1433_48261)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M11.4453 20.8756V20.2014L13.284 19.7417V25.1812H12.6328V20.5231L11.4453 20.8756Z",
    fill: "url(#paint9_linear_1433_48261)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M32.5235 34.5237C32.5235 34.5237 42.0353 29.7678 42.0353 22.6339V14.3111L32.5235 10.7441L23.0117 14.3111V22.6339C23.0117 29.7678 32.5235 34.5237 32.5235 34.5237Z",
    fill: "#D9D9D9"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M32.5235 34.5237C32.5235 34.5237 42.0353 29.7678 42.0353 22.6339V14.3111L32.5235 10.7441L23.0117 14.3111V22.6339C23.0117 29.7678 32.5235 34.5237 32.5235 34.5237Z",
    fill: "url(#paint10_linear_1433_48261)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M27.2598 20.8855L31.4562 25.0819L38.4501 18.0879",
    stroke: "white",
    strokeWidth: 2.09819,
    strokeLinecap: "round"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M13.8786 11.4539C12.8109 11.4539 11.9452 10.5881 11.9452 9.52053V3.33298C11.9452 3.02558 12.0674 2.73055 12.2847 2.51324C12.502 2.29593 12.7969 2.17374 13.1045 2.17374H13.106C13.7463 2.17374 14.2653 2.69265 14.2653 3.33298V8.74795C14.2653 8.96101 14.0925 9.13385 13.8794 9.13385H13.8786C13.6651 9.13385 13.4919 8.96062 13.4919 8.74718V4.1071C13.4919 3.89366 13.3187 3.72043 13.1052 3.72043C12.8918 3.72043 12.7186 3.89366 12.7186 4.1071V8.74718C12.7186 9.3879 13.238 9.9072 13.8786 9.9072H13.8794C14.5197 9.9072 15.0386 9.38829 15.0386 8.74795V3.33298C15.0386 2.26577 14.1732 1.40039 13.106 1.40039H13.1045C12.592 1.40039 12.1004 1.60417 11.738 1.96648C11.3755 2.32879 11.1719 2.82025 11.1719 3.33298V9.52053C11.1719 11.0154 12.3837 12.2272 13.8786 12.2272C14.5965 12.2272 15.2848 11.9423 15.7926 11.4346C16.3002 10.9269 16.5853 10.2386 16.5853 9.52053C16.5853 7.24264 16.5853 4.1071 16.5853 4.1071C16.5853 3.89366 16.4121 3.72043 16.1986 3.72043C15.9852 3.72043 15.812 3.89366 15.812 4.1071V9.52053C15.812 10.0333 15.6083 10.5251 15.2456 10.8878C14.8832 11.2501 14.3913 11.4539 13.8786 11.4539Z",
    fill: "#741437"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint0_linear_1433_48261",
    x1: 9.44594,
    y1: 4.26367,
    x2: 39.7461,
    y2: 45.3155,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#FF574D"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#D692FF"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint1_linear_1433_48261",
    x1: 25.2673,
    y1: 28.7393,
    x2: 25.2673,
    y2: 34.2554,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "white"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "white",
    stopOpacity: 0.74
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint2_linear_1433_48261",
    x1: 20.6677,
    y1: 28.7393,
    x2: 20.6677,
    y2: 34.2554,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "white"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "white",
    stopOpacity: 0.74
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint3_linear_1433_48261",
    x1: 16.4565,
    y1: 28.7393,
    x2: 16.4565,
    y2: 34.1787,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "white"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "white",
    stopOpacity: 0.74
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint4_linear_1433_48261",
    x1: 13.0072,
    y1: 28.7393,
    x2: 13.0072,
    y2: 34.1787,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "white"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "white",
    stopOpacity: 0.74
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint5_linear_1433_48261",
    x1: 29.2107,
    y1: 19.7417,
    x2: 29.2107,
    y2: 25.2578,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "white"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "white",
    stopOpacity: 0.74
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint6_linear_1433_48261",
    x1: 24.6228,
    y1: 19.7417,
    x2: 24.6228,
    y2: 25.2578,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "white"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "white",
    stopOpacity: 0.74
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint7_linear_1433_48261",
    x1: 20.3998,
    y1: 19.7417,
    x2: 20.3998,
    y2: 25.1812,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "white"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "white",
    stopOpacity: 0.74
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint8_linear_1433_48261",
    x1: 16.5759,
    y1: 19.7417,
    x2: 16.5759,
    y2: 25.2578,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "white"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "white",
    stopOpacity: 0.74
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint9_linear_1433_48261",
    x1: 12.3647,
    y1: 19.7417,
    x2: 12.3647,
    y2: 25.1812,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "white"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "white",
    stopOpacity: 0.74
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint10_linear_1433_48261",
    x1: 32.5235,
    y1: 10.7441,
    x2: 32.5235,
    y2: 34.5237,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#32FF84"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#2DC0FF"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_1433_48261"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 43.3074,
    height: 43.3074,
    fill: "white",
    transform: "translate(0.345703 0.498047)"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgMailCardIcon11);
export default __webpack_public_path__ + "static/media/mail_card_icon11.5053fb9459305d2519b5326910c3396f.svg";
export { ForwardRef as ReactComponent };